<template>
    <div class="modal_block">
        <div class="title">
          <p>{{simcard.imsi}}</p>
          <p>{{simcard.iccid}}</p>
        </div>
        <div class="">
          <div class="line">
            <div class="status">
              <label>
                {{ translate('simcard_profile.status') }}
              </label>
              <tree-select
                v-model="new_data.status"
                :options="status_list"
                :placeholder="translate('simcard_profile.status')"
                :clearable="true"
              />
            </div>
          </div>

            <div class="line">
              <div class="comment">
                <label>
                  {{ translate('simcard_profile.comment') }}
                </label>
                <textarea
                  v-model="new_data.comment"
                  rows="4"
                  class="form-control border-input"
                  :placeholder="translate('simcard_profile.comment')"
                />
              </div>
            </div>
        </div>
        <div class="text-center">
          <button class="btn btn-info btn-fill btn-wd marginButton" @click.prevent="setBlockedDevice">
            {{ translate('btn.edit') }}
          </button>

          <button class="btn btn-danger btn-fill btn-wd marginButton" @click.prevent="cancel">
            {{ translate('btn.close') }}
          </button>
        </div>
    </div>

</template>

<script>

export default {
  name: "ChangeStatus",
  props: [
      'simcard'
  ],

  data () {
    return {
      new_data:{
        comment: "",
        status: null
      }
    }
  },
  computed:{
    status_list(){
      return this.$store.getters.getSimcardProfileStatuses.map(status => {
        if (status.id !== -1){
          return {id: status.id, label: this.translate("simcard_profile.statuses." + status.title)}
        }
      }).filter((element) => { return element !== undefined })
    }
  },

  created() {
    this.new_data.status = this.simcard.status
  },
  methods: {
    setBlockedDevice(){
      this.$http.simcard.putSimcardStatus(this.simcard.id, this.new_data, (response) => {
        this.global_notify('info', this.translate('saved'))
        this.$store.dispatch('updateSimcardProfileProfile', this.simcard.imsi)
        this.$emit('close')
      })
    },
    cancel () {
      this.$emit('close')
    },
  }
}
</script>

<style lang='scss' scoped>
.modal_block{
  padding: 10px;
  .title{
    text-align: center;
  }
  .line{
    width: 100%;
    display: flex;
    align-content: center;
    justify-content: space-between;
    margin-bottom: 10px;
    .comment{
      width: 100%;
      margin-bottom: 10px;
    }
  }
}

</style>
